module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.NewsLetterSubscriber .Dialog":{"dialog.dialogClass":[{"value":"dark-overlay mc-site-common-popup mc-site-popup-bg","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~.NewsLetterSubscriber .Dialog","_fox_":1}],"dialog.width":[{"value":"385px","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.NewsLetterSubscriber .Dialog","_fox_":1}]},"~.NewsLetterSubscriber":{"handleWom.notValidForm.event":[{"value":"formNotValid","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.NewsLetterSubscriber","_fox_":1}],"handleWom.notValidForm.widget":[{"value":"#form #validator","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.NewsLetterSubscriber","_fox_":1}],"handleWom.notValidForm.callback":[{"value":function (data) {
fox.each(data.errorStack, function (v, field) {
var $el = $(this.dom1('[name="' + field + '"]'));
if ($el.length) {
$el.next().text(v[0].message);
}
}, this);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.NewsLetterSubscriber","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/newsLetterSubscriber.js
// module id = 1145
// module chunks = 4